    <div class="relative select-none w-full flex items-center justify-center min-h-0">
      <div #chartContainer echarts [options]="options"
           (chartInit)="onChartInit($event)"
           (chartMouseover)="onSegmentHover($event)"
           (chartMouseout)="onSegmentOut($event)"
           (chartClick)="onChartClick($event)"
           (chartContextMenu)="onChartContextMenu($event)"
           class="block w-full aspect-square max-w-[190px] mx-auto">
      </div>
      <!-- Center overlay -->
      <div class="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
        <span class="text-[11px] font-medium text-dim leading-none select-none">Total revenue</span>
        <span class="mt-1 text-[22px] font-bold text-ink leading-none select-none">{{ centerValue }}</span>
        <span class="mt-1 text-[11px] font-medium text-dim leading-none select-none">{{ periodLabel }}</span>
      </div>
    </div>
  
